import React from 'react';
import { UserIcon, CameraIcon } from '../../../../components/icons';
import { ClientProfile } from '../../../../types';

interface ProfileSummaryCardProps {
    formData: ClientProfile;
    user: any;
    planName: string;
}

const formatDate = (dateString: string | undefined) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR', { month: 'short', year: 'numeric' }).format(date);
};

export const ProfileSummaryCard: React.FC<ProfileSummaryCardProps> = ({
    formData,
    user,
    planName
}) => {
    return (
        <div className="card-premium flex flex-col items-center p-4 text-center">
            <div className="relative mb-3">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center text-primary overflow-hidden">
                    {formData.logoUrl ? (
                        <img src={formData.logoUrl} alt="Profile" className="w-full h-full object-cover" />
                    ) : (
                        <UserIcon className="w-10 h-10" />
                    )}
                </div>
                <button className="absolute bottom-0 right-0 p-1.5 bg-card rounded-full shadow-md border border-border text-muted hover:text-primary transition-colors">
                    <span className="sr-only">Alterar foto</span>
                    <CameraIcon className="w-3 h-3" />
                </button>
            </div>

            <h3 className="text-base font-bold text-secondary">{formData.name || user?.user_metadata?.full_name || 'Usuário'}</h3>
            <p className="text-xs text-muted mb-4">{formData.email}</p>

            <div className="w-full space-y-2">
                <div className="flex justify-between items-center py-1.5 border-b border-border">
                    <span className="text-xs text-muted">Membro desde</span>
                    <span className="text-xs font-semibold text-secondary">{formatDate(user?.created_at)}</span>
                </div>
                <div className="flex justify-between items-center py-1.5">
                    <span className="text-xs text-muted">Plano</span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary/10 text-primary">
                        {planName}
                    </span>
                </div>
            </div>
        </div>
    );
};
